// Phase 14e-a — /admin/rates index. Redirects to /admin/rates/cards
// per the 14e-a-2 lock (cards is the highest-traffic tab; runbook
// references can omit the /cards segment).

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/rates/')({
  beforeLoad: () => {
    throw redirect({ to: '/rates/cards' });
  },
});
